module.exports = __webpack_public_path__ + "static/img/p1.0e4135ca.png";